module.exports = __webpack_public_path__ + "static/media/formulario.473f2843.png";